import { render, staticRenderFns } from "./PlanBadge.vue?vue&type=template&id=c74f75a6&"
import script from "./PlanBadge.vue?vue&type=script&lang=js&"
export * from "./PlanBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports